const elementUIConverter = {
  "zh-CN": "zh-CN",
  "en-US": "en",
  "fr-FR": "fr"
}

module.exports = {
  elementUIConverter
}